import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataCharts } from 'src/app/model/installation/charts.model';
import { ErrorsReports } from 'src/app/model/installation/errors-reports.model';
import { Incidents } from 'src/app/model/installation/incidents.model';
import {
  ContratSav,
  Installation,
} from 'src/app/model/installation/installation.model';
import { Interventions } from 'src/app/model/installation/interventions.model';
import { Photo, Photos } from 'src/app/model/installation/photos.model';
import { Sales, totalSales } from 'src/app/model/installation/ventes.model';
import {
  BackupIncomplete,
  Installations,
  InstallListOwner,
  InstallNotConnect,
  SalesNotInService,
} from 'src/app/model/installations/installations.model';
import {
  APIUrls,
  WebConfigurationService,
} from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class InstallationsService extends WebConfigurationService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * Get the 'Installations' json data
   * @returns an Observable
   */
  public getInstallations(): Observable<Installations> {
    return this.authGetObs<Installations>(APIUrls.getInstallationUrl());
  }
  /**
   * Get the 'Rates' json data
   * @returns an Observable
   */
  public getRates(): Observable<any> {
    return this.authGetObs<any>(APIUrls.getRateUrl());
  }

  /**
   * Get the 'Rates' json data
   * @returns an Observable
   */
  public getRateBreakdown(month: string, type: any): Observable<any> {
    return this.authGetObs<any>(
      APIUrls.getRateUrl() + 'breakdown/' + month + '/' + type
    );
  }

  /**
   * Get one installation
   * @param id  the id of the installation
   * @returns an Observable
   */
  public getInstallation(id: string): Observable<Installation> {
    return this.authGetObs<Installation>(this.getInstallationUrl(id));
  }

  /**
   * GET the sales of one machine
   */
  public getSalesData(
    startMonth: number,
    startYear: number,
    monthCount: number,
    idMachine: number,
    idBackUp: number
  ): Observable<Sales> {
    return this.authGetObs<Sales>(
      this.getSalesUrl(startMonth, startYear, monthCount, idMachine, idBackUp)
    );
  }

  /**
   * GET the total of sales for one machine (year, cold pizza ...)
   */
  public getTotalSalesData(id: string) {
    return this.authGetObs<totalSales[]>(this.getTotalSalesUrl(id));
  }

  /**
   * GET the charts data for a machine.
   */
  public getChartsData(id: string): Observable<DataCharts> {
    return this.authGetObs<DataCharts>(this.getDataChartsUrl(id));
  }

  /**
   * GET the 'contrat SAV' datas for each machine
   */
  public getContratSavData(id: string): Observable<ContratSav> {
    return this.authGetObs<ContratSav>(this.getContratSavUrl(id));
  }

  /**
   * GET the 'interventions' datas for one machine
   */
  public getInterventionsData(
    id: string,
    p: string
  ): Observable<Interventions> {
    return this.authGetObs<Interventions>(this.getInterventionsUrl(id, p));
  }

  /**
   * GET the photos data for one machine
   */
  public getPhotosData(id: string): Observable<Photos> {
    return this.authGetObs<Photos>(this.getPhotosUrl(id));
  }

  /**
   * GET an image as base64 encoded string
   */
  public getPhoto(photo: Photo): Observable<string> {
    return this.authGetObs<string>(this.getPhotoUrl(photo));
  }

  /**
   * GET the pannes data for one instalation
   */
  public getPannesData(id: string, p: number): Observable<Incidents> {
    return this.authGetObs<Incidents>(
      APIUrls.getIncidentsInstallationUrl() + id + '/' + p
    );
  }

  /**
   * GET the breakdown solver for a panne
   */
  public getBreakdownsolver(id: number): Observable<any> {
    return this.authGetObs<any>(APIUrls.getBreakdownSolverUrl() + id);
  }

  /**
   * GET the errrors-reports data for one instalation
   */
  public getErrorsData(id: string, p: string): Observable<ErrorsReports> {
    return this.authGetObs<ErrorsReports>(
      APIUrls.getErrorsInstallationUrl() + id + '/' + p
    );
  }

  public connectToApd(machineSN: string): Observable<any> {
    return this.authGetObs<any>(this.getApdConnexionUrl(machineSN));
  }

  public getInstallOwnerList(): Observable<InstallListOwner[]> {
    return this.authGetObs<InstallListOwner[]>(APIUrls.getInstallOwnerUrl());
  }

  public getInstallationsNotConnectedList(): Observable<InstallNotConnect[]> {
    return this.authGetObs<InstallNotConnect[]>(
      APIUrls.getInstallNotConnectUrl()
    );
  }

  public getBackupsIncompleteList(): Observable<BackupIncomplete[]> {
    return this.authGetObs<BackupIncomplete[]>(
      APIUrls.getIncompleteBackupUrl()
    );
  }

  public getSalesNotInServiceList(): Observable<SalesNotInService[]> {
    return this.authGetObs<SalesNotInService[]>(
      APIUrls.getSalesNotInServiceUrl()
    );
  }

  public markAsDeal(id: number, traite: number) {
    return this.authGetObs<string>(APIUrls.markAsDealUrl() + id + '/' + traite);
  }
}
